<template>
  <div :class="$style['title-text']">
    <slot>
      {{ schedule.name }}
    </slot>
    <mds-tag-container>
      <mds-tag v-for="(tag, index) in tags" :key="index">
        {{ tag }}
      </mds-tag>
    </mds-tag-container>
    <div v-if="metadataItems.length > 0" :class="$style['title-supplemental-metadata-list']">
      <span
        v-for="(metadata, index) in metadataItems"
        :key="index"
        :class="$style['title-supplemental-metadata-list__item']"
      >
        <span :class="metadata.truncateClass" :title="getMetadataTitle(metadata)">
          {{ metadata.label }}
        </span>
        <slot v-if="metadata.showInfoIcons" name="infoIcon" :metadata="metadata"></slot>
      </span>
    </div>
  </div>
</template>

<script>
import { MdsTag, MdsTagContainer } from '@mds/tag';

export default {
  name: 'base-title',
  components: {
    MdsTag,
    MdsTagContainer,
  },
  props: {
    schedule: Object,
    metadataItems: Array,
  },
  inject: ['translate', 'formatNumber'],
  computed: {
    tags() {
      const tags = [];
      if (this.schedule.isFirmSaved) {
        tags.push(this.translate('firmSaved'));
      }
      if (this.schedule.isFirmData) {
        tags.push(this.translate('firmData'));
      }
      return tags;
    },
  },
  methods: {
    getMetadataTitle(metadata) {
      return metadata.enableTruncate ? metadata.label : undefined;
    },
  },
};
</script>

<style lang="scss" module>
@import '@mds/constants';
@import '@mds/typography';

.title-supplemental-metadata-list {
  display: flex;
  align-items: center;
  @include mds-ui-text-s();
  padding-top: $mds-space-1-x;
  &__item {
    display: flex;
    align-items: center;
    color: $mds-text-color-secondary;
    padding-right: $mds-space-half-x;

    &:last-child {
      padding-right: 0;
    }

    &:not(:first-child)::before {
      color: $mds-color-neutral-80;
      content: '\2022';
      padding-right: $mds-space-half-x;
    }
  }
}

.title-text {
  @include mds-level-5-heading($bold: true);
  margin-top: -2.5px;
  min-height: $mds-space-3-and-a-half-x;
}
</style>
